import { AxiosInstance, AxiosPromise } from 'axios';
import {
  OrderCommodityServicesEndpoints,
  SearchOrderCommoditiesRequest,
  SearchOrderCommoditiesResponse,
} from './OrderCommodityServices.types';

export class OrderCommodityServices implements OrderCommodityServicesEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchOrderCommoditiesRequest) {
    return this.instance.get<SearchOrderCommoditiesResponse>(
      `/orders/${request.routeParams.orderId}/commodities`,
      { params: request.queryParams },
    );
  }

  create(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
